module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10016.1c398878.jpg";